import { BrandMark } from "@/components/BrandMark";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function PendingAccess() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div data-testid="pending-access" className="surface p-10 max-w-md text-center rise">
        <BrandMark className="h-12 w-12 mx-auto mb-6" textClass="text-2xl" />
        <h1 className="font-heading text-2xl font-semibold">Akun belum diaktifkan</h1>
        <p className="text-sm text-muted-foreground mt-3">Halo {user.name}, akun <span className="font-mono">{user.email}</span> sudah terdaftar namun belum diberi peran. Hubungi Super Admin Yutaka untuk aktivasi dan penetapan vendor.</p>
        <Button data-testid="pending-logout-button" variant="outline" className="mt-8" onClick={logout}>Keluar</Button>
      </div>
    </div>
  );
}
